import { httpsCallable } from 'firebase/functions';
import { auth, hqFunctions } from '../firebase';

/**
 * Calls a HQ Cloud Function with automatic token-passing.
 * The current Ops user's Firebase Auth token is sent as `opsAuthToken` in the payload.
 * HQ Cloud Functions verify this token against the Ops project's Admin SDK.
 *
 * @param {string} fnName  Name of the Cloud Function (e.g. 'listMakes')
 * @param {object} data    Payload to send (excluding opsAuthToken — added automatically)
 * @returns {Promise<any>} Resolves to function's return value
 */
async function callHq(fnName, data = {}) {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('Not signed in. Cannot call HQ.');
  }
  const opsAuthToken = await user.getIdToken();
  const fn = httpsCallable(hqFunctions, fnName);
  const result = await fn({ ...data, opsAuthToken });
  return result.data;
}

// ---------- Read endpoints ----------

export const hqListMakes = () => callHq('listMakes');
export const hqGetMake = (makeId) => callHq('getMake', { makeId });
export const hqGetModelsByMake = (makeId, opts = {}) => callHq('getModelsByMake', { makeId, ...opts });
export const hqGetModel = (makeId, modelId) => callHq('getModel', { makeId, modelId });
export const hqGetPart = (partId) => callHq('getPart', { partId });
export const hqSearchModels = (query) => callHq('searchModels', { query });
export const hqWhoAmI = () => callHq('whoAmI');

// ---------- Submission endpoints ----------

export const hqSubmitMake = (data) => callHq('submitMake', data);
export const hqSubmitModel = (data) => callHq('submitModel', data);
export const hqSubmitSubCategory = (data) => callHq('submitSubCategory', data);
export const hqSubmitServiceInterval = (data) => callHq('submitServiceInterval', data);
export const hqSubmitDocument = (data) => callHq('submitDocument', data);
